
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm, reset } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import classNames from 'classnames';
import { CancelButton, SubmitButtonModal } from '../../../../components/buttons';
import { renderAutoCompleteSingleSelect, renderTextArea } from '../../../../components/reduxFields';
import {saveReasonCodeDetails, getMasterData, getReasonCodes, deleteReasonCode } from './actions/ManageClaimActions';
import { showFormatedDateandTime } from '../../../../actions/utilAction';
import SmallLoader from './../../../../img/small-loader.gif';
import { confirmAlert } from 'react-confirm-alert';
import TextField from 'material-ui/TextField';
import MaterialSelectField from 'mui-selectfield-search';
import Tooltip from 'material-ui/internal/Tooltip';

const validate = (values) => {
    const errors = {};

    if (!values.reasonCode) {
        errors.reasonCode = 'Please select Reason Code';
    }
    if ((values.reasonCode === 656 || values.reasonCode === 657 || values.reasonCode === 658) && !values.notes){
        errors.notes = 'Please enter notes'
    }
    return errors;
};

export const customRenderTextArea = ({
    input,
    label,
    fullWidth,
    disabled,
    autoHeight,
    rowsCount,
    meta: { touched, error },
    ...custom
  }) => {
    return (
      <TextField
        floatingLabelText={label}
        errorText={touched && error}
        multiLine={true}
        rows={rowsCount ? rowsCount : 3 }
        style={{overflowY: "hidden"}}
        //rowsMax={autoHeight ? null : 3}
        rowsMax={disabled ? null : 3}
        disabled={disabled}
        fullWidth={true}
        className="valuefont"
        autoComplete={'off'}
        floatingLabelStyle={{ color: '#7a7a7a' }}
        floatingLabelFocusStyle={{ color: '#09A7DC' }}
        {...input}
        {...custom} />
    );
  };

  export const customRenderAutoCompleteSingleSelect = ({
    input,
    label,
    value,
    meta: { touched, error },
    handleUpdateInput,
    handleNewRequest,
    options,
    hintText,
    disabled,
    openOnFocus, customError,
    className,
    ...custom
  }) => {
    let sourceArr = [];
    if (options && options.length) {
      options.map((obj) => {
        sourceArr[obj.id] = obj.value;
        return sourceArr;
      });
    }
  
    let optionsList = [];
    if (options && options.length) {
      if (label === 'Default Location') {
        optionsList = options.map(({ id, locationName }) => (
          <div key={id} value={id} label={locationName}>
            {locationName}
          </div>
        ));
  
      } else {
        optionsList = options.map(({ id, value }) => (
          <div key={id} className={className ? className : ''} value={id} label={value ? value.charAt(0).toUpperCase() + value.slice(1) : ''}>
            {value ? value.charAt(0).toUpperCase() + value.slice(1) : ''}
          </div>
        ));
      }
    }
    let selectedObj = null;
    if (typeof input === 'object') {
      if (options && options.length) {
        // if (options.length === 1) {
        //   selectedObj = { 'value': '', 'label': '' };
        //   selectedObj['value'] = options[0].id;
        //   selectedObj['label'] = label === 'Default Location' ? options[0].locationName : options[0].value.charAt(0).toUpperCase() + options[0].value.slice(1);
        // } else {
        options.map((i) => {
          if (i.id === input.value) {
            selectedObj = { 'value': '', 'label': '' };
            selectedObj['value'] = i.id;
            selectedObj['label'] = label === 'Default Location' ? i.locationName : i.value.charAt(0).toUpperCase() + i.value.slice(1);
          }
          return selectedObj;
        });
      }
    }
    const changeSelectedObj = (selectedValue) => {
      if (selectedValue === null) { //  Remove selection
        selectedObj = { 'value': '', 'label': '' };
        handleNewRequest(input, selectedObj);
      } else { // Apply Selection
        selectedObj = selectedValue;
        handleNewRequest(input, selectedValue);
      }
    };
  
    return (
      <MaterialSelectField
        disabled={disabled ? disabled : false}
        showAutocompleteThreshold={1}
        errorText={touched && (error || customError)}
        floatingLabel={label}
        hintText={hintText}
        floatingLabelStyle={{ color: 'rgb(122, 122, 122)' }}
        value={selectedObj}
        // nb2show={7}
        openOnFocus={openOnFocus}
        autocompleteUnderlineFocusStyle={{ display: 'none' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        required={true}
        // menuGroupStyle={{overflow:'scroll'}}
        onChange={(e) => changeSelectedObj(e)}
        hoverColor='rgba(3, 169, 244, 0.15)'  
        // style={{overflowY:"scroll"}}    
      >
        {optionsList}
      </MaterialSelectField>
    );
  };


class ReasonCodeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            claimId: props.claimId ? props.claimId : null,
            deleteModal : false,
            reasonCodeListing : [],
            reasonCodeLabel : '',
            reasonCodeId : null,
            isTooltipVisible : false,
            patientAppointmentId : null,
            // clientAddress : '',
        }
    }

    handleClose = async() => {
      try{
        await this.props.closeDialog();
        this.props.getAllEVVClaims();
      }catch(e){
        console.log("error after close",e)
      }
    }

    // componentWillMount() {
    //     let masterData = {'masterdata' : 'evvreasoncodes'}
    //     this.props.getMasterData(masterData);
    // }

    componentWillReceiveProps(nextProps) {
        if(nextProps.master_data && this.props.master_data !== nextProps.master_data){

            let masterData = nextProps.master_data;
            this.setState({
                reasonCodeListing : masterData.evvReasonCodes,
            })
        }
        // if(nextProps.getReasonCodeList && this.props.getReasonCodeList !== nextProps.getReasonCodeList){
        //     let data = nextProps.getReasonCodeList.data[0];
        //     this.setState({
        //         clientAddress : data && data.clientAddress? data.clientAddress : null
        //     })
        // }
        // if(nextProps.saveReasonCode && this.props.saveReasonCode !== nextProps.saveReasonCode){
        //     this.setState({ reasonCodeId : null}, () => {
        //         this.props.dispatch(reset('ReasonCodeModalForm'));
        //     })
        // }
        if(nextProps.readyToBillClaims){
          let reasonCodePatientAppointmentId = nextProps.readyToBillClaims.data.filter((obj)=>obj.claimId === this.props.claimId)
          let patientId = reasonCodePatientAppointmentId[0].claimEncounters && reasonCodePatientAppointmentId[0].claimEncounters[0].patientAppointmentId
          this.setState({
            patientAppointmentId : patientId})
        }
        if(nextProps.deleteReasonCode && this.props.deleteReasonCode !== nextProps.deleteReasonCode){
            this.loadData();
        }
        if(nextProps.saveReasonCode && this.props.saveReasonCode !== nextProps.saveReasonCode){
          this.loadData();
        }

    }
    componentDidUpdate(prevProps){
      if (prevProps.getReasonCodeList !== this.props.getReasonCodeList) {
        const data =this.props.getReasonCodeList && this.props.getReasonCodeList.data || [];
          data.forEach((Obj,index) => {
            this.props.dispatch(change('ReasonCodeModalForm', `ReasonCode[${index}].reasonCode`, Obj.reasonCodeId || null));
            this.props.dispatch(change('ReasonCodeModalForm', `ReasonCode[${index}].note`, Obj.note || ''));
        });
      }
    }

    componentDidMount =() =>{
        let masterData = {'masterdata' : 'evvreasoncodes'}
        this.props.getMasterData(masterData);
        this.loadData();
    }

    loadData = () => {
        this.props.getReasonCodes(this.props.claimId);
    }

    handleNewRequest = (input , selectedRecord) => {
        if(selectedRecord.value === 657|| selectedRecord.value === 658){
            this.props.dispatch(change('ReasonCodeModalForm', 'notes', this.props.patientAddress));
        }else {
            this.props.dispatch(change('ReasonCodeModalForm', 'notes', ''));
        }
        input.onChange(selectedRecord.value);
        this.setState({reasonCodeLabel : selectedRecord.label , reasonCodeId : selectedRecord.value})
    }

    handleNewRequestReasonCode = (input, selectedRecord, Obj) => {
        input.onChange(selectedRecord.value);
        let postData = {
            // "ClaimIds": this.props.claimId,
            "VisitChangesId": Obj.visitChangesId,
            "PatientAppointmentId" :this.state.patientAppointmentId,
            "reasonCode": selectedRecord.label,
            "note": Obj.note,
            "ReasonCodeId" : selectedRecord.value,
            }
         this.props.saveReasonCodeDetails(postData);
    }

    handleNotesChange = (event, Obj) => {
        let postData = {
            // "ClaimIds": this.props.claimId,
            "VisitChangesId": Obj.visitChangesId,
            "PatientAppointmentId" :this.state.patientAppointmentId,
            "reasonCode": Obj.reasonCode,
            "note": event.target.value,
            "ReasonCodeId" : Obj.reasonCodeId,
            }
        this.props.saveReasonCodeDetails(postData);
    }

    handleMouseEnter = () => {
        this.setState({isTooltipVisible : true})
      }
    
      handleMouseLeave = () => {
        this.setState({isTooltipVisible : false})
      }
    
      handleDeleteClick = (e, obj) => {
        this.setState({
            deleteModal: true
        });
    
        confirmAlert({
            title: 'Delete Selected Note',
            message: 'Are you sure you want to delete this Reason Code?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                  this.props.deleteReasonCode(obj.claimId, obj.visitChangesId);
                  this.setState({
                    deleteModal: false
                  })
                }
      
              },
              {
                label: 'No',
                onClick: () => {
                  this.setState({
                    deleteModal: false
                  })
                }
              }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
          });
    }
    onSubmitHandler = async (formProps) => {
      let postData = {
          // "ClaimIds": this.props.claimId,
          "VisitChangesId": 0,
          "PatientAppointmentId": this.state.patientAppointmentId,
          "reasonCode": this.state.reasonCodeLabel,
          "note": formProps.notes,
          "ReasonCodeId": this.state.reasonCodeId,
      };
      
      try {
          await this.props.saveReasonCodeDetails(postData);
          this.props.getAllEVVClaims(); // Reload data after saving
      } catch (error) {
          console.error("Error saving reason code details:", error); // Reference the error correctly
      }
  
      this.props.closeDialog(); // Close the dialog after submission
  }

    renderData = (reasonCodeListData) => {
        reasonCodeListData = reasonCodeListData || [];
        if (!reasonCodeListData.length) {
          return (
            <tr>
              <td colSpan="5">
                <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
              </td>
            </tr>
          );
        }
        return reasonCodeListData.map((Obj, index) => {
          return (
            <tr key={index}>
              <td width="20%">{showFormatedDateandTime(Obj.dateTime)}</td>
              <td width="15%">{Obj.staffName}</td>
              <td width="30%">
                <Field
                    name= {`ReasonCode[${index}].reasonCode`} 
                    hintText="Reason Code"
                    handleNewRequest={(input, selectedValue) => this.handleNewRequestReasonCode(input, selectedValue,Obj)}
                    options={this.props.master_data.evvReasonCodes}
                    component={customRenderAutoCompleteSingleSelect}
                /> 
              </td>
              <td width="30%">
                <div style={{ position: 'relative' }} 
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}>
                    <Field
                        name={`ReasonCode[${index}].note`}
                        label="Notes"
                        type="text"
                        maxLength="1000"
                        component={customRenderTextArea}
                        onBlur={(event) => this.handleNotesChange(event, Obj)} />
                      {this.state.isTooltipVisible && (
                        <Tooltip
                            label={Obj.note} 
                            show={true} 
                            style={{ position: 'absolute', top: '-10px' }}
                        />
                    )}
                </div>
              </td>
              <td width="5%">
                <button 
                onClick={(e) => this.handleDeleteClick(e, Obj)} 
                type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
            </td>
            </tr>
          )
        })
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { handleSubmit , getReasonCodeList } = this.props;
        let reasonCodeListData = (getReasonCodeList && getReasonCodeList.data) || [];
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <div>
               {!this.state.deleteModal && <Dialog
                    className="custom_modal_new_appointment"
                    title='ADD/EDIT REASON CODE'
                    modal={false}
                    open={true}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    <div className="row">
                        <div className="col-sm-12">
                            <form className="readmin-form custom_form" >
                                <div className="row">
                                <div className='col-sm-12 require  mt-35'>
                                    <Field
                                        name="reasonCode"
                                        label="Reason Code"
                                        options={this.props.master_data.evvReasonCodes}
                                        handleNewRequest={this.handleNewRequest}
                                        component={renderAutoCompleteSingleSelect} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className= {this.state.reasonCodeId === 656 || this.state.reasonCodeId === 657 || this.state.reasonCodeId === 658 ? "col-sm-12 require mt-30" : "col-sm-12 mt-30"}>
                                        <Field
                                            name="notes"
                                            label="Notes"
                                            type="text"
                                            maxLength="1000"
                                            component={renderTextArea}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 pt20 btn_rt">
                                        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
                                        <SubmitButtonModal className="ml_15" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} primary={true} label="Save" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="table-responsive mt-15">
                        <table className={tableClass}>
                        <thead>
                            <tr>
                                <th width="30%">Date and Time</th>
                                <th width="20%">Staff Name</th>
                                <th width="20%">Reason Code</th>
                                <th width="20%">Notes</th>
                                <th width="10%">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderData(reasonCodeListData)}
                        </tbody>
                        </table>
                        {/* {
                        NotesMeta && NotesMeta['totalPages']
                            ?
                            <PaginatorCustom data={NotesMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                            :
                            null
                        } */}
                    </div>
                </Dialog>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        master_data : state.billing.master_data,
        getReasonCodeList : state.billing.get_ReasonCode,
        saveReasonCode : state.billing.saved_ReasonCode,
        deleteReasonCode : state.billing.delete_ReasonCode,
        readyToBillClaims: state.billing.readyToBillClaims,
    };
};

ReasonCodeModal = reduxForm({
    form: 'ReasonCodeModalForm', // a unique identifier for this form
    validate,
})(ReasonCodeModal);

export default connect(mapStateToProps, { saveReasonCodeDetails , getMasterData ,getReasonCodes, deleteReasonCode })(ReasonCodeModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/ReasonCodeModal.js